import loadable from '@loadable/component';

export const AnalyticsPage = loadable(/* #__LOADABLE__ */ () => import('./AnalyticsPage'));
